const crypto = require('crypto');  
const utf8 = require('utf8');
export function crotoMessage(msg) {
    const cipher = crypto.createCipher('aes-256-cbc', 'dj39fy212f');
    let cryptoJson = cipher.update(JSON.stringify(msg), 'utf8', 'base64'); // 'HbMtmFdroLU0arLpMflQ'
    cryptoJson += cipher.final('base64'); // 'HbMtmFdroLU0arLpMflQYtt8xEf4lrPn5tX5k+a8Nzw='
    return cryptoJson;
}
export function decrptoMessage(msg) {
  const decipher = crypto.createDecipher('aes-256-cbc', 'dj39fy212f');
  let result2 = decipher.update(msg, 'base64', 'utf8'); // 암호화할문 (base64, utf8이 위의 cipher과 반대 순서입니다.)
  result2 += decipher.final('utf8'); // 암호화할문장 (여기도 base64대신 utf8)
  return result2;
}
export function sha256Crypto(msg) {
  let sha256Pass = crypto.createHash('sha512').update(msg).digest('base64');
  return sha256Pass;
}

// xor 암호화
export function xorDecryption(crypt, key) {
  var buf = Buffer.from(decodeURIComponent(crypt), 'base64'); // Ta-da
  var output = "";
  var charCode;
  var keyCode = key.charCodeAt(0);
  for (var i = 0; i < buf.length; i++) {
      charCode = buf.readUInt8(i) ^ keyCode;
      output += String.fromCharCode(charCode);
  }
  return utf8.decode(output) ;
}
// xor 암호화
export function xorEncryption(crypt, key) {
  var buf = Buffer.from(crypt); 
  var output = Buffer.alloc(buf.length);
  var charCode;
  var keyCode = key.charCodeAt(0);
  for (var i = 0; i < buf.length; i++) {
      charCode = buf.readUInt8(i) ^ keyCode;
      output.writeUInt8(charCode, i);
  }
  return encodeURIComponent(output.toString('base64'));
}